import VueJsonViewer from 'vue-json-viewer'

export default {
    name: 'RawDocumentTab',
    components: {
        VueJsonViewer
    },
    props: {
        recallData: {
            type: Object,
            default: null
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        displayData() {
            if (!this.recallData || !this.recallData.recall_info) return null
            // Create a deep copy of recall_info
            const modifiedData = JSON.parse(JSON.stringify(this.recallData.recall_info))
            // Replace recall_category with recall_group
            if (modifiedData.recall_category !== undefined) {
                modifiedData.recall_group = modifiedData.recall_category
                delete modifiedData.recall_category
            }
            return modifiedData
        }
    },
    methods: {
        copyToClipboard() {
            if (!this.displayData) return

            const jsonString = JSON.stringify(this.displayData, null, 2)
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(jsonString)
                    .then(() => {
                        this.$bvToast.toast('JSON copied to clipboard', {
                            title: 'Success',
                            variant: 'success',
                            solid: true,
                            autoHideDelay: 2000
                        })
                    })
                    .catch(err => {
                        console.error('Failed to copy:', err)
                        this.fallbackCopy(jsonString)
                    })
            } else {
                this.fallbackCopy(jsonString)
            }
        },

        fallbackCopy(text) {
            // Fallback method for older browsers
            const textArea = document.createElement('textarea')
            textArea.value = text
            textArea.style.position = 'fixed'
            textArea.style.left = '-999999px'
            document.body.appendChild(textArea)
            textArea.select()

            try {
                document.execCommand('copy')
                this.$bvToast.toast('JSON copied to clipboard', {
                    title: 'Success',
                    variant: 'success',
                    solid: true,
                    autoHideDelay: 2000
                })
            } catch (err) {
                console.error('Fallback: Failed to copy:', err)
                this.$bvToast.toast('Failed to copy JSON', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true,
                    autoHideDelay: 3000
                })
            }

            document.body.removeChild(textArea)
        }
    }
}
